module.exports = __webpack_public_path__ + "media/images/dashboard/colorSilver-f6d7e5a639590f9690884f6ab5046bd1.svg";